// Company Logo
export const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_cc9367ce-7fd0-434d-a0ea-a3a4b782073e/artifacts/awhz1f5s_LOGOO.jpg";

// Company Information
export const COMPANY_INFO = {
  name: "M 360 Commodities",
  tagline: "Global Supplier of Metals, Minerals, Fuels & Raw Materials",
  mission: "To provide consistent, high-quality commodities while ensuring secure, compliant, and timely delivery, empowering industries and businesses to thrive globally.",
  vision: "To be recognized as a trusted and preferred partner in global commodities trading, known for professionalism, reliability, and excellence in service."
};

// About Content
export const ABOUT_CONTENT = {
  description: "M 360 Commodities is a leading global supplier and trading partner specializing in metals, minerals, fuels, and strategic raw materials. With a commitment to quality, transparency, and efficiency, we connect producers and buyers worldwide, providing reliable sourcing solutions that meet international standards.",
  foundation: "Founded on the principles of integrity and trust, M 360 Commodities leverages an extensive global network of mining partners, refineries, and industrial suppliers to deliver premium products, including copper, lithium, coltan, zinc, manganese, gold, sulphur, and specialty fuels such as EN590 diesel, JetFuel A and Lubricants."
};

// Why Choose Us
export const WHY_CHOOSE_US = [
  {
    title: "Global Sourcing Network",
    description: "Access to verified and trusted suppliers worldwide"
  },
  {
    title: "Quality Assurance",
    description: "Rigorous standards and certified products"
  },
  {
    title: "Competitive Pricing",
    description: "Optimized procurement and cost-efficiency"
  },
  {
    title: "Reliable Logistics",
    description: "Efficient, secure, and timely delivery"
  },
  {
    title: "Compliance & Transparency",
    description: "Full regulatory adherence and documentation"
  }
];

// Minerals and Metals Products
export const MINERALS_METALS = [
  {
    id: 1,
    name: "Copper Cathodes",
    shortDesc: "Premium-grade copper cathodes with 99.97% - 99.99% purity, meeting international LME Grade A standards.",
    purity: "99.97% – 99.99% Cu",
    grade: "LME Grade A",
    applications: ["Electrical wires and power cables", "Electronics and semiconductors", "Construction and infrastructure", "Automotive manufacturing", "Industrial equipment production"]
  },
  {
    id: 2,
    name: "Copper Concentrate",
    shortDesc: "High-quality copper concentrate sourced from trusted mining partners for smelters and refiners worldwide.",
    content: "20% – 35% Cu Content",
    moisture: "8% – 10%",
    applications: ["Smelting and refining processes", "Production of refined copper and cathodes", "Metallurgical industries", "Alloy and industrial manufacturing"]
  },
  {
    id: 3,
    name: "Lithium Ore",
    shortDesc: "Premium lithium ore supporting the growing demand for energy storage and advanced manufacturing.",
    type: "Spodumene / Lepidolite",
    content: "2% – 6% Li₂O",
    applications: ["Lithium-ion battery production", "Electric vehicles (EVs)", "Energy storage systems", "Glass and ceramics manufacturing", "Industrial lubricants and alloys"]
  },
  {
    id: 4,
    name: "Coltan",
    shortDesc: "Critical mineral for advanced electronics with verified sourcing and assay certification.",
    content: "20% – 40% Ta₂O₅",
    origin: "Africa (DRC, Rwanda)",
    applications: ["Electronics (smartphones, laptops, capacitors)", "Aerospace and defense components", "Medical equipment", "Superalloys and high-temperature applications"]
  },
  {
    id: 5,
    name: "Zinc",
    shortDesc: "High-purity zinc in various forms for industrial and manufacturing sectors.",
    purity: "98% – 99.995%",
    forms: "Zinc ingots / zinc metal / concentrates",
    applications: ["Galvanization of steel", "Construction and infrastructure", "Automotive manufacturing", "Battery production", "Die-casting and alloy production"]
  },
  {
    id: 6,
    name: "Manganese",
    shortDesc: "Essential raw material for steel production and industrial applications.",
    content: "25% – 50% Mn",
    forms: "Lumps / fines / concentrate",
    applications: ["Steel manufacturing (alloying agent)", "Battery production", "Chemical and fertilizer industries", "Glass and ceramics production", "Industrial alloys and processing"]
  },
  {
    id: 7,
    name: "Californium",
    shortDesc: "Highly regulated radioactive element for specialized nuclear and medical applications.",
    isotope: "Cf-252",
    note: "Strictly regulated - licensed entities only",
    applications: ["Nuclear reactors and research", "Neutron radiography", "Medical treatments (cancer therapies)", "Industrial inspection and material analysis", "Mining and exploration"]
  },
  {
    id: 8,
    name: "Malachite",
    shortDesc: "Copper-rich mineral valued for industrial processing and decorative applications.",
    formula: "Cu₂CO₃(OH)₂",
    forms: "Raw ore / lumps / decorative stone",
    applications: ["Copper extraction and processing", "Jewelry and decorative items", "Interior design and ornamental stone", "Collectibles and mineral specimens", "Pigments"]
  },
  {
    id: 9,
    name: "Gold",
    shortDesc: "Trusted sourcing of gold for investors, jewelers, and industrial users worldwide.",
    purity: "99.5% – 99.99%",
    standard: "LBMA / Good Delivery",
    applications: ["Jewelry and luxury products", "Investment and bullion reserves", "Electronics and high-tech industries", "Medical devices and dental applications", "Central bank holdings"]
  },
  {
    id: 10,
    name: "Sulphur",
    shortDesc: "High-quality sulphur for fertilizers, chemicals, and energy sectors.",
    purity: "99.5% – 99.9%",
    forms: "Granular / lump / powder",
    applications: ["Fertilizer production (sulphuric acid)", "Chemical manufacturing", "Petroleum refining", "Rubber processing", "Pharmaceuticals and industrial applications"]
  }
];

// Oil and Gas Products
export const OIL_GAS = [
  {
    id: 1,
    name: "EN590 Diesel",
    shortDesc: "Ultra-low sulphur diesel meeting European and global standards for automotive and industrial use.",
    standard: "EN590 (European Standard)",
    cetane: "≥51",
    sulphur: "≤10 ppm (ultra-low sulphur)",
    applications: ["Automotive diesel engines", "Industrial diesel generators", "Agricultural machinery", "Marine and transportation fuel", "Power generation plants"]
  },
  {
    id: 2,
    name: "Jet Fuel A",
    shortDesc: "Aviation-grade turbine fuel compliant with international aviation standards.",
    standard: "ASTM D1655 / DEF STAN 91-91",
    freezingPoint: "≤-40°C",
    flashPoint: "≥38°C",
    applications: ["Commercial and cargo aircraft", "Private jets and business aviation", "Military turbine engines", "Helicopters and aviation training"]
  },
  {
    id: 3,
    name: "D6 Fuel",
    shortDesc: "High-speed industrial diesel for heavy-duty machinery and marine vessels.",
    specification: "ASTM D975 / EN 590",
    flashPoint: "≥60°C",
    applications: ["Heavy-duty diesel engines", "Industrial machinery and generators", "Marine vessels and ships", "Construction and mining equipment", "Backup power supply systems"]
  },
  {
    id: 4,
    name: "Engine Oil",
    shortDesc: "Premium engine oils for automotive, industrial, and heavy-duty machinery applications.",
    grades: "SAE 5W-30, 10W-40, 15W-40",
    standards: "API, ACEA",
    applications: ["Automotive cars, trucks, and buses", "Industrial engines and generators", "Heavy machinery in construction and mining", "Marine and aviation equipment"]
  }
];

// Contact Information
export const CONTACT_INFO = {
  email: "info@m360commodities.com",
  offices: [
    {
      location: "Canada (Head Office)",
      address: "2550 Matheson Blvd E, Unit: 216, Mississauga, ON, L4W 4Z3",
      phone: "1-647-740-0280"
    },
    {
      location: "USA Office",
      address: "2408 WINEWOOD LN ARLINGTON TX, USA 76013",
      phone: "1-647-740-0280"
    },
    {
      location: "Dubai Office",
      address: "Apricot Towers - Office No. 511-3, 5th Floor, Dubai Silicon Oasis, Dubai UAE",
      phone: "+971 50 871 0321"
    }
  ]
};
